import { Icons } from '@shared/components/content/icons';
import { cn } from '@shared/lib/utils';
import React from 'react';

const logoWhite = new URL(
  '@shared/components/logo/assets/logo-name-white.png',
  import.meta.url
).href;

interface ProductPdfPageProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * react-to-pdf slices the rendered canvas into A4 pages (29.7cm) from the
   * top. Every page except the last must therefore be exactly one page tall
   * so the slices line up; the final page is kept marginally shorter so
   * rounding never spills onto an empty trailing page.
   */
  last?: boolean;
}

export function ProductPdfPage({
  last = false,
  className,
  children,
  ...props
}: ProductPdfPageProps) {
  return (
    <div
      className={cn(
        'flex w-[21cm] flex-col border border-primary bg-gray-00',
        last ? 'h-[29.5cm]' : 'h-[29.7cm]',
        className
      )}
      {...props}
    >
      {/* Header */}
      <div className="flex h-[58px] shrink-0 items-center justify-between bg-primary-800 px-6">
        <img src={logoWhite} alt="My Emissions" className="h-7" />
        <span className="text-sm font-medium text-primary-50">
          Product carbon assessment
        </span>
      </div>

      {children}

      {/* Footer */}
      <div className="mt-auto flex h-[58px] shrink-0 items-center justify-between border-t border-teal-200 bg-teal-50 px-6">
        <p className="text-xs font-light text-primary-800">
          For more information on product carbon labelling, get in touch:
        </p>
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-1">
            <Icons.mail size={16} className="text-teal-500" />
            <span className="text-xs font-medium text-teal-500">
              hello@myemissions.co
            </span>
          </div>
          <div className="flex items-center gap-1">
            <Icons.link size={16} className="text-teal-500" />
            <a
              href="https://myemissions.co"
              className="text-xs font-medium text-teal-500"
            >
              myemissions.co
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
